import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { TableModule } from 'primeng/table';
import { SliderModule } from 'primeng/slider';
import { MultiSelectModule } from 'primeng/multiselect';
import { ContextMenuModule } from 'primeng/contextmenu';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { TabViewModule } from 'primeng/tabview';
import { CodeHighlighterModule } from 'primeng/codehighlighter';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TipoProcessoComponent } from './modules/module-app/components/configuracoes/tipo-processo/tipo-processo.component';
import { DataDismissDirective } from './modules/shared/directives/data-dismiss.directive';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DataTablesModule } from 'angular-datatables';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoginComponent } from './modules/module-app/components/login/login.component';
import { BodySizeDirective } from './modules/shared/directives/body-size.directive';
import { MenuLateralComponent } from './modules/module-app/components/dashboard/menu-lateral/menu-lateral.component';
import { SlideMenuDirective } from './modules/shared/directives/slide-menu.directive';
import { NivelServicoComponent } from './modules/module-app/components/configuracoes/nivel-servico/nivel-servico.component';
import { MonitorProcessosComponent } from './modules/module-app/components/dashboard/monitor-processos/monitor-processos.component';
import { UploadDocumentosComponent } from './modules/module-app/components/upload-documentos/upload-documentos.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { CadastroPoderesComponent } from './modules/module-app/components/cadastro-poderes/cadastro-poderes.component';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { DisableClickDirective } from './modules/shared/directives/disable-click.directive';
import { FeitoConferidoComponent } from './modules/module-app/components/feito-conferido/feito-conferido.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InterceptorService } from './modules/shared/services/geral/interceptor.service';
import { TooltipModule } from 'ng2-tooltip-directive';
import { PopoverModule } from "ngx-popover";
import { ChartModule } from 'primeng/chart';
import { CadastroPoderesClienteComponent } from './modules/module-app/components/cadastro-poderes/cadastro-poderes-cliente/cadastro-poderes-cliente.component';
import { CadastroPoderesInternosComponent } from './modules/module-app/components/cadastro-poderes-internos/cadastro-poderes-internos.component';
import { AssinaturaInternaComponent } from './modules/module-app/components/assinatura-interna/assinatura-interna/assinatura-interna.component';
import { ControleDocumentosComponent } from './modules/module-app/components/dashboard-documentos/controle-documentos/controle-documentos.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { Ng2LoadingSpinnerModule } from 'ng2-loading-spinner';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EasyPieChartDirective } from './modules/shared/directives/easy-pie-chart.directive';
import { BlankComponent } from './modules/module-app/components/blank/blank.component';
import { ClienteSemAutorizadorComponent } from './modules/module-app/components/cliente-sem-autorizador/cliente-sem-autorizador.component';
import { SidebarMenuDirective } from './modules/shared/directives/sidebar-menu.directive';
import { MenuSizeDirective } from './modules/shared/directives/menu-size.directive';
import { SignalRModule } from 'ng2-signalr';
import { SignalRConfiguration } from 'ng2-signalr';
import { FileSaverModule } from 'ngx-filesaver';
import { registerLocaleData, APP_BASE_HREF } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID } from '@angular/core';
import { HelperFunctionsComponent, getBaseLocation } from './modules/module-app/components/helper/helper-functions/helper-functions.component';
// import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';


registerLocaleData(localePt);

export function createConfig(): SignalRConfiguration {
  const c = new SignalRConfiguration();
  c.hubName = 'MonitorHub';
  c.qs = null;
  c.url = 'http://localhost:1986';
  c.logging = true;

  // >= v5.0.0
  c.executeEventsInZone = true; // optional, default is true
  c.executeErrorsInZone = false; // optional, default is false
  c.executeStatusChangeInZone = true; // optional, default is true
  return c;
}

@NgModule({
  declarations: [
    AppComponent,
    TipoProcessoComponent,
    DataDismissDirective,
    LoginComponent,
    BodySizeDirective,
    MenuLateralComponent,
    SlideMenuDirective,
    NivelServicoComponent,
    MonitorProcessosComponent,
    UploadDocumentosComponent,
    CadastroPoderesComponent,
    DisableClickDirective,
    FeitoConferidoComponent,
    CadastroPoderesClienteComponent,
    CadastroPoderesInternosComponent,
    AssinaturaInternaComponent,
    ControleDocumentosComponent,
    EasyPieChartDirective,
    BlankComponent,
    ClienteSemAutorizadorComponent,
    SidebarMenuDirective,
    MenuSizeDirective,
    HelperFunctionsComponent
  ],
  imports: [
    FileSaverModule,
    NgxDropzoneModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    DataTablesModule,
    FormsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    Ng2SmartTableModule,
    TableModule,
    SliderModule,
    DialogModule,
    MultiSelectModule,
    ContextMenuModule,
    DropdownModule,
    ButtonModule,
    ToastModule,
    InputTextModule,
    TabViewModule,
    CodeHighlighterModule,
    InputSwitchModule,
    TooltipModule,
    PopoverModule,
    ChartModule,
    AutoCompleteModule,
    CalendarModule,
    Ng2LoadingSpinnerModule.forRoot({
      spinnerFontSize: '14px',
      animationType: 'scalingBars',
      backdropColor: 'rgba(0, 0, 0, 0.2)'
    }),
    NgbModule,
    SignalRModule.forRoot(createConfig),
    // NgxExtendedPdfViewerModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: APP_BASE_HREF, useFactory: getBaseLocation }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
